<!--
 * @Author: p_fy
 * @Date: 2019-07-17 13:47:49
 * @LastEditors: l_hc
 * @LastEditTime: 2019-10-18 18:30:57
 * @Description: 预约窗口，提示成功以及预约信息。
 -->
<!-- 预约看仓 -->
<template>
  <div class="transport-news">
    <el-dialog
      :visible.sync="orderVisible"
      title="预约看仓"
      width="408px"
      @close="$emit('close', false)"
    >
      <div class="order-wrap">
        <span>{{ title }}</span>
        <span>供给方联系信息</span>
      </div>
      <el-form ref="form" :model="form" :rules="formRules" label-width="83px">
        <ul class="order-ul">
          <li>联系人：{{ orderData.linkMan }}</li>
          <li>联系电话：{{ orderData.telephone }}</li>
          <!-- <li>预约时间：{{ form.leasetime }}</li> -->
          <li>地址：{{ orderData.storageLocationLabel }}</li>
        </ul>
        <el-row style="text-align: left;margin-left: 10px;">
          <el-col :span="24">
            <el-form-item label="预约时间" prop="leasetime">
              <el-date-picker
                v-model="form.leasetime"
                :editable="false"
                type="datetime"
                placeholder="选择日期"
                :picker-options="pickerOptions"
                :disabled="timeType"
              />
            </el-form-item>
          </el-col>
        </el-row>
        <div style="text-align: center;">
          <el-button v-if="!timeType" type="danger" plain size="small" @click="dealSave">预约</el-button>
        </div>
      </el-form>
    </el-dialog>
  </div>
</template>
<script>
import moment from 'moment'
import { appointment } from '@/api/cloud/storage-supply-info/storageSupplyInfo'

export default {
  name: 'OrderWarehousing',
  components: {
  },
  props: {
    orderManager: { type: Boolean, default: () => false }, // 弹窗控制
    orderData: { type: Object, default: () => {} }, // 当前预约元素
    orderType: { type: String, default: () => '' } // 当前预约元素
  },
  data() {
    return {
      orderVisible: this.orderManager,
      form: {
        leasetime: null
      },
      timeType: false,
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() < Date.now() - 8.64e7
        }
      },
      title: '预约看仓',
      formRules: {
        leasetime: [{ required: true, message: '请选择预约时间' }]
      }
    }
  },
  watch: {
    orderManager() {
      this.orderVisible = this.orderManager
      this.orderData.orderDate = moment(new Date()).format('YYYY-MM-DD HH:mm:ss')
      if (!this.orderManager) {
        this.title = '预约看仓'
        this.timeType = false
        this.$refs['form'].resetFields()
        this.form = {
          leasetime: null
        }
      }
    }
  },
  methods: {
    dealSave() {
      this.$refs['form'].validate(valid => {
        if (valid) {
          appointment({
            appointmentDate: this.form.leasetime,
            supplyId: this.orderData.id,
            contactMan: this.orderData.linkMan,
            tel: this.orderData.telephone,
            demandType: this.orderType,
            goodsType: this.orderData.storageType,
            appointmentPoint: this.orderData.storageLocation
          }).then(res => {
            this.$message({
              message: '恭喜您，预约成功！',
              type: 'success'
            })
            this.title = '恭喜您，预约成功！'
            this.timeType = true
            this.$emit('close', false)
          }).catch(err => {
            console.log(err)
          })
        }
      })
    }
  }
}
</script>

<style scoped lang='scss'>
  $o: "order-";
  $main-color: #be2316;
  .transport-news{
    margin-bottom: 1rem;
  }
  /deep/.#{$o}wrap{
    // display: grid;
    display: flex;
    flex-direction: column;
    text-align: center;
    span{
      font-family:MicrosoftYaHei;
      font-weight:600;
      line-height:39px;
      &:nth-child(1){
        font-size:18px;
        color:rgba(190,35,22,1);
      }
      &:nth-child(2){
        font-size:14px;
        color:rgba(153,153,153,1)
      }
    }
  }
  /deep/.#{$o}ul{
    margin: 30px 0px 10px 23px;
    >li{
      font-size:14px;
      font-family:MicrosoftYaHei;
      font-weight:400;
      color:rgba(85,85,85,1);
      line-height:33px;
    }
  }
</style>

